import { withAuth } from '@okta/okta-react';
import PropTypes from 'prop-types';
import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Image, Menu, Message } from 'semantic-ui-react';
import logo from '../../../../assets/img/aarp-logo.svg';
import { HasWapFullElseUpdateRole, HasWapFullRole, HasWapUpdateRole, HasWapUserAdminRole } from '../../containers/Authorization';
import { getNotificationMessage, handleLocalSearchInputStorage } from '../../containers/Utils/index';
import './styles.css';

const Admin = props => (
  <HasWapUserAdminRole>
    <Menu.Item as={NavLink} content="User-Admin" to="/searchusers" />
  </HasWapUserAdminRole>
);

const Enroll = props => (
  <HasWapFullRole>
    <Menu.Item as={NavLink} content="Enroll" to="/enroll" />
  </HasWapFullRole>
);
const Renew = props => (
  <HasWapFullRole>
    <Menu.Item as={NavLink} content="Renew/Update" to="/search" />
  </HasWapFullRole>
);

const Update = props => (
  <HasWapUpdateRole>
    <Menu.Item as={NavLink} content="Update" to="/update" />
  </HasWapUpdateRole>
);

const logOut = (props) => {
  props.auth.logout();
  handleLocalSearchInputStorage('remove', '');
};

const RenewOrUpdate = HasWapFullElseUpdateRole(Renew, Update);

export const SiteHeaderMobileComponent = props => (
  <Menu fixed="top" inverted styleName="header">
    <Menu.Item as={Link} to="/search">
      <Image
        src={logo}
        title="click to return to the homepage"
        width="139px"
        height="36px"
      />
    </Menu.Item>
    <Menu.Menu position="right">
      <Admin />
      <Enroll />
      <RenewOrUpdate />
      <Menu.Item
        as="a"
        content={props.auth._oktaAuth.tokenManager.get('idToken').claims.email}
        onClick={() => logOut(props)}
        title="Click to Logout"
      />
    </Menu.Menu>
  </Menu>
);

SiteHeaderMobileComponent.propTypes = {
  auth: PropTypes.any,
  onSidebarToggle: PropTypes.func,
};

export const SiteHeaderDesktopComponent = props => (
  <Menu fixed="top" inverted styleName="header">
    <Menu.Item as={Link} to="/search">
      <Image
        src={logo}
        title="click to return to the homepage"
        width="139px"
        height="36px"
      />
    </Menu.Item>
    {
      getNotificationMessage().message !== '' ?
        <Message styleName="message-container">
          <Message.Header>{getNotificationMessage().header}</Message.Header>
          <p>
            {getNotificationMessage().message}
          </p>
        </Message>
        : null
    }
    <Menu.Menu position="right">
      <Admin />
      <Enroll />
      <RenewOrUpdate />
      <Menu.Item
        as="a"
        content={props.auth._oktaAuth.tokenManager.get('idToken').claims.email}
        onClick={() => logOut(props)}
        title="Click to Logout"
      />
    </Menu.Menu>
  </Menu>
);

SiteHeaderDesktopComponent.propTypes = {
  auth: PropTypes.any,
};

export const SiteHeaderMobile = withAuth(SiteHeaderMobileComponent);
export const SiteHeaderDesktop = withAuth(SiteHeaderDesktopComponent);



// WEBPACK FOOTER //
// ./src/app/components/SiteHeader/index.js